import React from 'react';
import { Formik, Form } from 'formik';
import { DeactivateAccountSchema } from '../../../schemas';
import { PrimaryButton, ErrorButton } from "../../UI";
import { FormikInput } from '../Formik';
import { useContentfulContext } from '../../../contexts/ContentfulContext';

const DeactivateAccountForm = ({ submitHandler, handleCancelClick }) => {
    const { content } = useContentfulContext();

    return (
        <Formik
            initialValues={{
                email: '',
            }}
            validationSchema={() => DeactivateAccountSchema(content.DEACTIVATE_ACCOUNT_MODAL)}
            onSubmit={async () => {
                submitHandler();
            }}
        >
            {() => (
                <Form className="space-y-4 md:space-y-6" action="#">
                    <FormikInput
                        type="email"
                        name="email"
                        id="email"
                        label={content.DEACTIVATE_ACCOUNT_MODAL.formLabels.email}
                        placeholder="Enter email to confirm"
                    />
                    <div className="mb-4 space-x-4 flex items-center">
                        <ErrorButton type="submit">{content.DEACTIVATE_ACCOUNT_MODAL.formLabels.cta_text}</ErrorButton>
                        <PrimaryButton handleClick={handleCancelClick}>{content.DEACTIVATE_ACCOUNT_MODAL.formLabels.cancel_text}</PrimaryButton>
                    </div>
                </Form>
            )}
        </Formik>
    );
};

export default DeactivateAccountForm;
